import { Form, FormInstance, Row } from "antd";
import { DisbursementsMethodPart } from "./components/DisbursementMethodPart";
import { StatusPart } from "./components/StatusPart";
import { MainPart } from "./components/MainPart";
import { useGetInitialValues } from "./hooks/useGetInitialValues";
import { Loader } from "../../../../../../../../components/Loader";
import { FeeOverridePart } from "./components/FeeOverridePart";
import { useButtonHandlers } from "./hooks/useButtonHandlers";
import { useCallback, useMemo, useState } from "react";
import { FormButtons } from "./components/FormButtons";
import { TRecord } from "./types";
import { useInitialFormValues } from "./hooks/useInitailFormValues";

type TPayeeFormProps = {
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  reloadData: (isNew?: boolean) => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contractId: string;
  setRecord: React.Dispatch<React.SetStateAction<TRecord>>;
  record: TRecord;
  isPassthru: boolean;
};

export const PayeeForm = ({
  reloadData,
  setIsOpen,
  payeesNumber,
  contractId,
  setRecord,
  record,
  isPassthru
}: TPayeeFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { initial } = useInitialFormValues();

  const [disbursementMethodState, setDisbursementMethodState] = useState({
    isEscrowAcc: false,
    isACHMethod: false
  });

  const [payeeStatusState, setPayeeStatusState] = useState({
    isActive: true,
    isAmountNonNullOrZero: true,
    isEnableForPayments: true
  });

  const reload = useCallback(
    (isNew?: boolean) => {
      reloadData(isNew);

      isNew && form.resetFields();
    },
    [form, reloadData]
  );

  const { onCancelClick, onDeleteBtnClick, onSaveBtnClick, isFormDisabled } = useButtonHandlers({
    reload,
    setIsOpen,
    setRecord,
    form
  });

  const { isLoading } = useGetInitialValues(
    record.id,
    form,
    setDisbursementMethodState,
    setPayeeStatusState,
    isPassthru
  );

  const payeeFormClassName = useMemo(() => {
    return `payee-disbursements-form-wrapper
      ${isLoading && "h-100"}
      w-100
      pb-16
      position-relative
      justify-center
      align-center`;
  }, [isLoading]);

  return (
    <Row className={payeeFormClassName}>
      {isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <>
          <Form
            form={form}
            requiredMark={false}
            layout="vertical"
            className="w-100 pt-8 px-6 mb-4 payee-disbursements-form overflow-y-auto"
            disabled={isFormDisabled}
            initialValues={initial}
          >
            <MainPart
              form={form}
              payeesNumber={payeesNumber}
              isFormDisabled={isFormDisabled}
              isPassthru={isPassthru}
              payeeStatusState={payeeStatusState}
              setPayeeStatusState={setPayeeStatusState}
            />
            <DisbursementsMethodPart
              form={form}
              contractId={contractId}
              disbursementMethodState={disbursementMethodState}
              isFormDisabled={isFormDisabled}
            />
            <StatusPart form={form} payeeStatusState={payeeStatusState} setPayeeStatusState={setPayeeStatusState} />
            <FeeOverridePart form={form} isFormDisabled={isFormDisabled} />
          </Form>
          <FormButtons
            onSaveClick={onSaveBtnClick}
            onCancelClick={onCancelClick}
            onDeleteClick={onDeleteBtnClick}
            isFormDisabled={isFormDisabled}
            record={record}
          />
        </>
      )}
    </Row>
  );
};
